module.exports = __webpack_public_path__ + "img/1026155491.f06ba98a.png";